import React from "react";
import { Link } from "gatsby-plugin-react-i18next";
import starIcon from "../../assets/images/star-icon.png";
import bench1 from "../../assets/images/blog/bench-mv.jpg";
import bench2 from "../../assets/images/blog/bench-mv-open.jpg";
import bench3 from "../../assets/images/blog/bench-li-ym.jpg";
import user1 from "../../assets/images/user1.jpg";
import shape1 from "../../assets/images/shape/vector-shape1.png";
import shape2 from "../../assets/images/shape/vector-shape2.png";
import { useTranslation } from "gatsby-plugin-react-i18next";

const F = () => {
	const { t } = useTranslation();

	return (
		<section className="blog-area pt-100 pb-70 bg-fffbf5">
			<div className="container">
				<div className="section-title">
					<span className="sub-title">
						<img src={starIcon} alt="blog" />
						{t("home.Fp01")}
					</span>
					<h2>{t("home.Fh2")}</h2>
					<p>{t("home.Fp02")}</p>
				</div>

				<div className="row align-items-center">
					<div className="col-lg-4 col-md-6">
						<div className="single-blog-post">
							<div className="post-image">
									<img src={bench1} alt="blog" />
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user1}
												className="rounded-circle"
												alt="blog"
											/>
											<span>{t("home.Fi01")}</span>
										</div>
									</li>
								</ul>
								<h3>{t("home.Fh3a")}</h3>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6">
						<div className="single-blog-post">
							<div className="post-image">
									<img src={bench2} alt="blog" />
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user1}
												className="rounded-circle"
												alt="blog"
											/>
											<span>{t("home.Fi02")}</span>
										</div>
									</li>
								</ul>
								<h3>{t("home.Fh3b")}</h3>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
						<div className="single-blog-post">
							<div className="post-image">
									<img src={bench3} alt="blog" />
							</div>

							<div className="post-content">
								<ul className="post-meta d-flex justify-content-between align-items-center">
									<li>
										<div className="post-author d-flex align-items-center">
											<img
												src={user1}
												className="rounded-circle"
												alt="blog"
											/>
											<span>Yannick Molinier</span>
										</div>
									</li>
								</ul>
								<h3>{t("home.Fh3c")}</h3>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="vector-shape1">
				<img src={shape1} alt="shape" />
			</div>
			<div className="vector-shape2">
				<img src={shape2} alt="shape" />
			</div>
		</section>
	);
};

export default F;
